import React from 'react';

const HIGH_TYPES = [
  'drone_attack', 'missile_attack', 'hijack_attempt',
  'vessel_seizure', 'armed_robbery', 'piracy', 'attack',
];
const ELEVATED_TYPES = [
  'suspicious_approach', 'piracy_approach', 'sighting',
  'missile_sighting', 'vessel_harassment', 'incident',
];

function getSeverity(type) {
  if (HIGH_TYPES.includes(type))     return { label: 'HIGH',     cls: 'wr-sev-high' };
  if (ELEVATED_TYPES.includes(type)) return { label: 'ELEVATED', cls: 'wr-sev-elevated' };
  return { label: 'ADVISORY', cls: 'wr-sev-advisory' };
}

function relTime(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const h    = Math.floor(diff / 3600000);
  if (h < 1)  return 'just now';
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export default function IncidentTicker({ incidents, onChipClick }) {
  const recent = (incidents || []).slice(0, 3);
  if (!recent.length) return null;

  return (
    <div className="wr-ticker">
      <div className="wr-ticker-label">
        <span className="wr-ticker-dot" />
        Recent Incidents
      </div>
      <div className="wr-ticker-chips">
        {recent.map(inc => {
          const sev  = getSeverity(inc.type);
          const zone = inc.zone || inc.zone_name || '—';
          const type = (inc.type || 'incident').replace(/_/g, ' ');
          const date = inc.date || inc.published;

          return (
            <button
              key={inc.id}
              className="wr-ticker-chip"
              onClick={() => onChipClick(inc)}
            >
              <span className={sev.cls}>{sev.label}</span>
              <span className="wr-ticker-zone">{zone}</span>
              <span className="wr-ticker-type">{type}</span>
              <span className="wr-ticker-time">{date ? relTime(date) : '—'}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
